import React from "react";
import styles from "./GuideCard.module.scss";
import openCallImage from "../../../assets/images/open-call-image.jpg";

const GuideCard = ({ item }) => {
  return (
    <div className={styles.card} onClick={() => console.log("Card clicked.")}>
      <div className={styles.image}>
        <img src={item.image} alt={item.subTitle} />
      </div>
      <div className={styles.info}>
        <h2 className={styles.title}>{item.title}</h2>
        <p className={styles.description}>{item.description}</p>
        <div className={styles.readMore}>
          <button>Read More</button>
        </div>
      </div>
    </div>
  );
};

export default GuideCard;
